export interface IModuleQuestionFieldI18n {
	readonly label: string;
	readonly locale: string;
	readonly placeholder: string;
}

export class ModuleQuestionFieldI18n {
	private _label: string;
	private _locale: string;
	private _placeholder: string;

	constructor(label: string, locale: string, placeholder: string) {
		this._label = label;
		this._locale = locale;
		this._placeholder = placeholder;
	}

	public get label(): string {
		return this._label;
	}

	public get locale(): string {
		return this._locale;
	}

	public get placeholder(): string {
		return this._placeholder;
	}
}
